module.exports = __webpack_public_path__ + "img/close-white.878c7a59.svg";